/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerGetProjectQuotaQueryResponse, OrganizationsControllerGetProjectQuotaPathParams, OrganizationsControllerGetProjectQuota400, OrganizationsControllerGetProjectQuota401, OrganizationsControllerGetProjectQuota403, OrganizationsControllerGetProjectQuota404 } from "../../models/organizationsController/OrganizationsControllerGetProjectQuota";

function getOrganizationsControllerGetProjectQuotaUrl(id: OrganizationsControllerGetProjectQuotaPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/organizations/${id}/project-quota` as const }  
  return res
}

/**
 * @summary Get org-wide EMS project usage versus the entitlement cap. Returns null used/total when EMS validation is off for the organization or quota does not apply.
 * {@link /api/v1/organizations/:id/project-quota}
 */
export async function organizationsControllerGetProjectQuota(id: OrganizationsControllerGetProjectQuotaPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerGetProjectQuotaQueryResponse, ResponseErrorConfig<OrganizationsControllerGetProjectQuota400 | OrganizationsControllerGetProjectQuota401 | OrganizationsControllerGetProjectQuota403 | OrganizationsControllerGetProjectQuota404>, unknown>({ method : "GET", url : getOrganizationsControllerGetProjectQuotaUrl(id).url.toString(), ... requestConfig })  
  return res.data
}